import { atom } from 'recoil';
import { ViewManager } from '~/engine/view/ViewManager';

/**
 * True while a mounted viewer surface can put a load on screen: the
 * viewport grid while it is mounted with the engine, since its rows bind
 * what the load registers.
 *
 * {@link viewManagerState} cannot answer this: it is a page-lifetime
 * singleton that stays non-null after the viewport unmounts, so gating on
 * it would drive the previous mount's detached canvases. Written by
 * `GridViewport`, and cleared on its teardown.
 */
export const viewportReadyState = atom<boolean>({
    key: 'viewportReadyState',
    default: false,
});

export const viewManagerState = atom<ViewManager | null>({
    key: 'viewManagerState',
    default: null,
    dangerouslyAllowMutability: true,
});
